import {
  BASE_PATH_API,
  STATIC_TOKEN_CONNECTION,
  PATH_GET_MENUS,
  PATH_GET_INIT_DATA,
  PATH_GET_INIT_DATA_ITEMS_ADQ,
  PATH_GET_INIT_DATA_CENTROS_COSTO,
  PATH_GET_INIT_DATA_PROVEEDORES,
  PATH_GET_INIT_DATA_CUENTAS_CONTABLES,
  PATH_GET_INIT_DATA_ITEMS_CONTABLES,
  PATH_GET_INIT_DATA_NATURALEZAS_CONTABLES,
  PATH_GET_PRESUPUESTOS,
  PATH_GET_INIT_DATA_TIPOS_SOLICITUD,
  PATH_GET_INIT_DATA_MESES,
  PATH_GET_INIT_DATA_ESTADOS_OP,
  PATH_GET_INIT_DATA_TIPOS_MONEDA,
  TIPO_DOCUMENTO_SOLICITUDES,
  PATH_GET_INIT_DATA_ESTADOS_SOLICITUD,
  PATH_GET_INIT_DATA_DOC_TRIBUTARIOS,
  PATH_GET_INIT_DATA_TIPOS_ITEMS_ADQ,
  PATH_GET_INIT_DATA_USER_PROFILE,
  PATH_GET_INIT_DATA_DEV,
  PATH_GET_INIT_DATA_PARAMS,
  PATH_GET_INIT_DATA_ESTADOS_ORDENES,
  PATH_GET_INIT_DATA_USER_APROBADORES,
  PATH_GET_INIT_DATA_CONDICIONES_PAGO,
} from "./Constants";

class APIError extends Error {
  type: any;
  status: any;
  statusText: string;
  constructor(
    res: Response,
    data: { errors?: any; error?: any; message?: any; type?: any },
  ) {
    super(
      data.errors
        ? data.errors[0]
        : data.error || data.message || res.statusText || res.status,
    );

    this.name = "APIError";
    this.type = data.type;
    this.status = res.status;
    this.statusText = res.statusText;
  }
}

function useQuery() {
  return new URLSearchParams(window.location.search);
}

function getToken() {
  //ES POSIBLE REQUERIR LLAMAR A ACQUIRETOKEN DESDE AQUI SI NO SE ENCUENTRA VALIDO EL TOKEN
  const sessionStorageTokenApi = sessionStorage.getItem("accessToken");
  if (sessionStorageTokenApi !== null) {
    return sessionStorageTokenApi;
  }
  return null;
}

function buildPath(path: string[]) {
  const normalizedPath = path[0] === "/" ? path : `${path}`;
  return BASE_PATH_API + normalizedPath;
}

async function makeRequest(
  path: string[],
  options: {
    method?: "GET" | undefined;
    body?: any | undefined;
    headers?: { [key: string]: string } | undefined;
  },
) {
  try {
    const { method = "GET", body, headers = {} } = options;

    const normalizedBody =
      typeof body === "object" ? JSON.stringify(body) : body;
    headers["Authorization"] = `Bearer ${getToken()}`;
    //}

    headers["Content-Type"] = "application/json";
    headers["Accept"] = "application/json";
    headers["Access-Control-Allow-Origin"] =
      "https://fishweb.salmonesdechile.com, http://localhost:3000";
    headers["Access-Control-Allow-Methods"] =
      "GET, POST, PATCH, PUT, DELETE, OPTIONS";
    headers["Access-Control-Allow-Headers"] =
      "Origin, Content-Type, X-Auth-Token";

    return new Request(buildPath(path), {
      method,
      body: normalizedBody,
      headers,
    });
  } catch (error) {
    console.log(error);
  }
}

async function callApi(
  path: string[],
  options: { method: "GET"; body?: any | undefined },
) {
  const req = await makeRequest(Array.isArray(path) ? path : [path], options);
  if (!req) {
    throw new Error("Failed to create request");
  }
  const res = await window.fetch(req);

  if (!res.ok) {
    let data = {};
    try {
      data = await res.json();
    } catch (error) {
      console.log("ERROR: " + error);
    }
    throw new APIError(res, data);
  }

  if (res.status === 204) {
    return;
  }

  if (res.status === 202) {
    return 202;
  }

  if (res.status === 404) {
    return 404;
  }

  if (res.status === 500) {
    return 500;
  }

  try {
    const respuesta = await res.json();

    if (respuesta === null || respuesta === undefined) {
      console.log("No data returned from API");
    } else {
      return respuesta;
    }
  } catch (e) {
    console.log(e);
    return {};
  }
}

/***************************************************************/
/*********************  API CALLS ******************************/
/***************************************************************/

export const GET_MENUS = {
  async getMenusByUserRols(userId: any) {
    var path = [`${PATH_GET_MENUS}/${userId}`];
    const data = await callApi(path, {
      method: "GET",
    });
    return data;
  },
};

export const GET_INIT_DATA_USER = {
  async getInitDataUser() {
    var path = [`${PATH_GET_INIT_DATA}`];
    const data = await callApi(path, {
      method: "GET",
    });
    return data;
  },
};

export const GET_INIT_DATA_USER_DEV = {
  async getInitDataUserDev(email: string) {
    const data = fetch(`${BASE_PATH_API}${PATH_GET_INIT_DATA_DEV}/${email}`, {
      headers: {
        method: "GET",
        "Content-Type": "application/json",
        Accept: "application/json",
        "Access-Control-Allow-Origin":
          "http://localhost:3000, https://fishweb.salmonesdechile.com",
        "Access-Control-Allow-Methods":
          "GET, POST, PATCH, PUT, DELETE, OPTIONS",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
      },
    });
    return data;
  },
};

export const GET_INIT_DATA_ITEMS_ADQ = {
  async getInitDataItemsAdq() {
    var path = [`${PATH_GET_INIT_DATA_ITEMS_ADQ}`];
    const data = await callApi(path, {
      method: "GET",
    });
    return data;
  },
};

export const GET_INIT_DATA_CENTROS_COSTO = {
  async getInitDataCentrosCosto() {
    var path = [`${PATH_GET_INIT_DATA_CENTROS_COSTO}`];
    const data = await callApi(path, {
      method: "GET",
    });
    return data;
  },
};

export const GET_INIT_DATA_PROVEEDORES = {
  async getInitDataProveedores() {
    var path = [`${PATH_GET_INIT_DATA_PROVEEDORES}`];
    const data = await callApi(path, {
      method: "GET",
    });
    return data;
  },
};

export const GET_ITEM_AQQ_BY_ID = {
  async getItemAdquisicionById(id: number) {
    var path = [`${PATH_GET_INIT_DATA_ITEMS_ADQ}/${id}`];
    const data = await callApi(path, {
      method: "GET",
    });
    return data;
  },
};

export const GET_INIT_DATA_CUENTAS_CONTABLES = {
  async getInitDataCuentasContables() {
    var path = [`${PATH_GET_INIT_DATA_CUENTAS_CONTABLES}`];
    const data = await callApi(path, {
      method: "GET",
    });
    return data;
  },
};

export const GET_CUENTA_CONTABLE = {
  async getCuentaContableById(id: number) {
    var path = [`${PATH_GET_INIT_DATA_CUENTAS_CONTABLES}/${id}`];
    const data = await callApi(path, {
      method: "GET",
    });
    return data;
  },
};

export const GET_INIT_DATA_CUENTAS_CONTABLES_ITEMS = {
  async getInitDataCuentasContablesItems() {
    var path = [`${PATH_GET_INIT_DATA_ITEMS_CONTABLES}`];
    const data = await callApi(path, {
      method: "GET",
    });
    return data;
  },
};

export const GET_CUENTA_CONTABLE_ITEM = {
  async getCuentaContableItemById(id: number) {
    var path = [`${PATH_GET_INIT_DATA_ITEMS_CONTABLES}/${id}`];
    const data = await callApi(path, {
      method: "GET",
    });
    return data;
  },
};

export const GET_CUENTAS_CONTABLES_ITEMS_NATURALEZAS = {
  async getCuentasContablesItemsNaturalezas() {
    var path = [`${PATH_GET_INIT_DATA_NATURALEZAS_CONTABLES}`];
    const data = await callApi(path, {
      method: "GET",
    });
    return data;
  },
};

export const GET_CUENTA_CONTABLE_ITEM_NATURALEZA = {
  async getCuentaContableItemNaturalezaById(id: number) {
    var path = [`${PATH_GET_INIT_DATA_NATURALEZAS_CONTABLES}/${id}`];
    const data = await callApi(path, {
      method: "GET",
    });
    return data;
  },
};

export const GET_PRESUPUESTOS = {
  async getPresupuestos() {
    var path = [`${PATH_GET_PRESUPUESTOS}`];
    const data = await callApi(path, {
      method: "GET",
    });
    return data;
  },
};

export const GET_PRESUPUESTO = {
  async getPresupuestoById(id: number) {
    var path = [`${PATH_GET_PRESUPUESTOS}/${id}`];
    const data = await callApi(path, {
      method: "GET",
    });
    return data;
  },
};

export const GET_INIT_DATA_TIPOS_SOLICITUD = {
  async getTiposSolicitud() {
    var path = [
      `${PATH_GET_INIT_DATA_TIPOS_SOLICITUD}/${TIPO_DOCUMENTO_SOLICITUDES}`,
    ];
    const data = await callApi(path, {
      method: "GET",
    });
    return data.map(({ id, nombre }: { id: number; nombre: string }) => ({
      id,
      nombre,
    }));
  },
};

export const GET_INIT_DATA_MESES = {
  async getMeses() {
    var path = [`${PATH_GET_INIT_DATA_MESES}`];
    const data = await callApi(path, {
      method: "GET",
    });
    return data.map(({ id, nombre }: { id: number; nombre: string }) => ({
      id,
      nombre,
    }));
  },
};

export const GET_INIT_DATA_ESTADOS_OP = {
  async getEstadosOperacionales() {
    var path = [`${PATH_GET_INIT_DATA_ESTADOS_OP}`];
    const data = await callApi(path, {
      method: "GET",
    });
    return data.map(({ id, nombre }: { id: number; nombre: string }) => ({
      id,
      nombre,
    }));
  },
};

export const GET_INIT_DATA_TIPOS_MONEDA = {
  async getTiposMoneda() {
    var path = [`${PATH_GET_INIT_DATA_TIPOS_MONEDA}`];
    const data = await callApi(path, {
      method: "GET",
    });
    return data.map(({ id, nombre }: { id: number; nombre: string }) => ({
      id,
      nombre,
    }));
  },
};

export const GET_INIT_DATA_ESTADOS_SOLICITUD = {
  async getEstadosSolicitud() {
    var path = [`${PATH_GET_INIT_DATA_ESTADOS_SOLICITUD}`];
    const data = await callApi(path, {
      method: "GET",
    });
    return data.map(({ id, nombre }: { id: number; nombre: string }) => ({
      id,
      nombre,
    }));
  },
};

export const GET_INIT_DATA_DOC_TRIBUTARIOS = {
  async getTiposDocTributarios() {
    var path = [`${PATH_GET_INIT_DATA_DOC_TRIBUTARIOS}`];
    const data = await callApi(path, {
      method: "GET",
    });
    return data.map(({ id, nombre }: { id: number; nombre: string }) => ({
      id,
      nombre,
    }));
  },
};

export const GET_INIT_DATA_ESTADOS_ORDENES = {
  async getEstadosOrdenes() {
    var path = [`${PATH_GET_INIT_DATA_ESTADOS_ORDENES}`];
    const data = await callApi(path, {
      method: "GET",
    });
    return data.map(({ id, nombre }: { id: number; nombre: string }) => ({
      id,
      nombre,
    }));
  },
};

export const GET_INIT_DATA_TIPOS_ITEMS_ADQ = {
  async getTiposItemsAdq() {
    var path = [`${PATH_GET_INIT_DATA_TIPOS_ITEMS_ADQ}`];
    const data = await callApi(path, {
      method: "GET",
    });
    return data;
  },
};

export const GET_INIT_DATA_PARAMS = {
  async getParametrosGenerales() {
    var path = [`${PATH_GET_INIT_DATA_PARAMS}`];
    const data = await callApi(path, {
      method: "GET",
    });
    return data;
  },
};

export const GET_INIT_DATA_USER_APROBADORES = {
  async getAprobadoresSolicitude() {
    var path = [`${PATH_GET_INIT_DATA_USER_APROBADORES}`];
    const data = await callApi(path, {
      method: "GET",
    });
    return data;
  },
};

export const GET_INIT_DATA_CONDICIONES_PAGO = {
  async getCondicionesPago() {
    var path = [`${PATH_GET_INIT_DATA_CONDICIONES_PAGO}`];
    const data = await callApi(path, {
      method: "GET",
    });
    return data.map(({ id, nombre }: { id: number; nombre: string }) => ({
      id,
      nombre,
    }));
  },
};

// Función para llamar a la API protegida (refactorizada para ser llamada desde login o botón)
export const callProtectedApi = async (
  accessToken: any,
  instance: any,
  protectedApiRequest: any,
  accounts: any,
  userEmail: any,
) => {
  let tokenToUse = accessToken;

  try {
    if (!tokenToUse) {
      // Si no se proporciona un token, intenta adquirirlo
      // Intenta adquirir un token de acceso silenciosamente
      const response = await instance.acquireTokenSilent({
        ...protectedApiRequest,
        account: accounts[0], // Usa la primera cuenta autenticada
      });
      tokenToUse = response.accessToken;
    }
    sessionStorage.setItem("accessToken", tokenToUse);
    // Haz la llamada a tu API de NestJS, incluyendo el token de acceso en el encabezado Authorization
    const apiEndpoint = `${PATH_GET_INIT_DATA_USER_PROFILE}`; // ¡REEMPLAZA con la URL de tu API!
    const apiRes = await fetch(apiEndpoint, {
      headers: {
        method: "GET",
        Authorization: `Bearer ${tokenToUse}`,
        "Content-Type": "application/json",
        Accept: "application/json",
        "Access-Control-Allow-Origin":
          "http://localhost:3000, https://fishweb.salmonesdechile.com",
        "Access-Control-Allow-Methods":
          "GET, POST, PATCH, PUT, DELETE, OPTIONS",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
      },
    });
    if (!apiRes.ok) {
      throw new Error(`HTTP error! status: ${apiRes.status}`);
    }

    return apiRes;
  } catch (error) {
    console.error("Error calling protected API:", error);
    // Si acquireTokenSilent falla, intenta con un popup (o redirección)
    if (
      typeof error === "object" &&
      error !== null &&
      "name" in error &&
      (error as { name?: string }).name === "InteractionRequiredAuthError" &&
      !accessToken
    ) {
      // Solo si no teníamos un token inicial
      try {
        const popupResponse = await instance.acquireTokenPopup({
          ...protectedApiRequest,
          account: accounts[0],
        });
        // Reintentar la llamada a la API con el token obtenido por popup
        const apiEndpoint = `${PATH_GET_INIT_DATA_USER_PROFILE}/${userEmail}`;
        const apiRes = await fetch(apiEndpoint, {
          headers: {
            Authorization: `Bearer ${popupResponse.accessToken}`,
          },
        });

        if (!apiRes.ok) {
          throw new Error(`HTTP error! status: ${apiRes.status}`);
        }

        const data = await apiRes.json();

        return data;
      } catch (popupError) {
        console.error(
          "Error acquiring token via popup or calling API:",
          popupError,
        );
      }
    } else {
      console.error("Error al llamar a la api para un access token:");
    }
  } finally {
    // Finalizar la carga de la API
  }
};
